import { render } from "./sidepane-communication.vue?vue&type=template&id=67a31a37&scoped=true"
import script from "./sidepane-communication.vue?vue&type=script&lang=js"
export * from "./sidepane-communication.vue?vue&type=script&lang=js"

import "./sidepane-communication.vue?vue&type=style&index=0&id=67a31a37&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67a31a37"]])

export default __exports__